import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  AggregateService,
  ExcelExportProperties,
  GridComponent,
  GroupSettingsModel,
  ToolbarItems,
} from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';
import { L10n } from '@syncfusion/ej2-base';
import { MonthlyDocumentCountRes } from 'src/app/core/services/AdminService/admin-service-generate';

L10n.load({
  tr: {
    gridMonthly: {
      Excelexport: 'Excel-İndir',
    },
  },
});

@Component({
  selector: 'app-all-services-monthly-document-count-dialog',
  templateUrl: './all-services-monthly-document-count-dialog.component.html',
  styleUrls: ['./all-services-monthly-document-count-dialog.component.css'],
  providers: [AggregateService],
})
export class AllServicesMonthlyDocumentCountDialogComponent implements OnInit {
  dailyDocumentCountData: MonthlyDocumentCountRes[];
  @ViewChild('gridMonthly') public gridMonthly?: GridComponent;

  groupOptions: GroupSettingsModel = {
    showDropArea: false,
    columns: ['month', 'documentType'],
  };
  gridLines;
  public orderDateFormat: any;

  tabLabelDayParentName: string;
  tabLabelDocumentCountParentName: string;
  tabLabelDirectionParentName: string;
  public toolbarOptions?: object[];

  constructor(private translateService: TranslateService) {
    this.tabLabelDayParentName =
      this.translateService.instant('DASHBOARDPAGE.Day');
    this.tabLabelDocumentCountParentName = this.translateService.instant(
      'DASHBOARDPAGE.DocumentCount'
    );
    this.tabLabelDirectionParentName = this.translateService.instant(
      'DASHBOARDPAGE.Direction'
    );
  }

  ngOnInit(): void {
    this.gridLines = 'Both';
    this.orderDateFormat =
      localStorage.getItem('lang') === 'tr-TR'
        ? { type: 'date', format: 'dd.MM.yyyy' }
        : { type: 'date', format: 'yyyy.MM.dd' };
    this.toolbarOptions = [
      { text: this.translateService.instant('SHARED.EXPORT_EXCEL') },
    ];
  }

  toolbarClick(args: ClickEventArgs): void {
    if (
      (args as any).item.text ===
      this.translateService.instant('SHARED.EXPORT_EXCEL')
    ) {
      // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      const excelExportProperties: ExcelExportProperties = {
        exportType: 'CurrentPage',
      };
      (this.gridMonthly as any).excelExport(excelExportProperties);
    }
  }
}
